<template>
	<Sidebar
		v-model:visible="showPanel"
		:position="props.position"
		:modal="true"
		:dismissable="props.dismissable"
		:closeOnEscape="false"
		appendTo="body"
		:blockScroll="true"
		:class="sidebarClassList"
	>
		<template #container="{ closeCallback }">
			<div
				v-if="props.headerStyle != 'author' && props.headerStyle != 'complaince' && props.headerStyle != 'report' && props.headerStyle != 'callAssistantModal' && props.headerStyle != 'readCallAssistant'"
				class="p-3"
				:class="headerClass"
			>
				<div class="flex items-center">
					<div class="flex-grow flex items-center gap-2">
						<!-- <div class="rounded-full w-[35px] h-[25px] relative">
							<span class="absolute left-0 right-0">	
								<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>

								<img class="rounded-full w-15px h-15px right-[-6px] top-[-6px] absolute" src="../../assets/images/reto-krapf-236x300.jpg" alt="">
							</span>
						</div> -->
						<!-- <div class="rounded-full w-[35px] h-[25px] relative" v-if="props.headerStyle == 'complaince'">
							<span class="absolute left-0 right-0">	
								<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
								<EwIcon icon="tabler:file-check flex" class="rounded-full w-15px h-15px right-[-6px] top-[-6px] absolute"/>
							</span>
						</div>
						<div class="rounded-full w-[35px] h-[25px] relative" v-if="props.headerStyle == 'helpSupportAssistant'">
							<span class="absolute left-0 right-0">	
								<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
								<EwIcon icon="tabler:books" class="rounded-full w-15px h-15px right-[-6px] top-[-6px] absolute"/>
							</span>
						</div>
						<div class="rounded-full w-[35px] h-[25px] relative" v-if="props.headerStyle == 'report'">
							<span class="absolute left-0 right-0">	
								<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
								<EwIcon icon="tabler:chart-infographic" class="rounded-full w-15px h-15px right-[-6px] top-[-6px] absolute"/>
							</span>
						</div> -->
						<div class="">
							<EwIcon :icon="props.icon" class="w-5 h-5" />
						</div>
						<div class="text-sm sm:text-md font-medium leading-tight" v-tooltip.bottom="props.title">
							{{ props.title }}
						</div>
					</div>
					<EwIcon
						icon="tabler:x"
						class="cursor-pointer w-8 h-8 sm:w-5 sm:h-5"
						@click="handleClose(closeCallback)"
					/>
				</div>
				<div>{{ props.description }}</div>
			</div>
			<slot name="sidepanelnav" />
			<div class="flex-grow overflow-y-hidden" :class="{ 'p-0': !props.empty && !props.compactContent }">
				<slot />
			</div>
			<div
				class="p-2 flex bg-dark"
				v-if="
					props.headerStyle === 'print' ||
					props.headerStyle === 'slideshow' ||
					props.headerStyle === 'feedback' ||
					!['report', 'callAssistantModal', 'complaince', 'author', 'dark', 'lngReviewEdit', 'notification', 'slideshowEdit', 'readCallAssistant'].includes(props.headerStyle)
				"
			>
				<slot name="footer" :close="closeCallback">
					<div v-if="$slots.footerleft">
						<slot name="footerleft" />
					</div>
					<div class="flex ml-auto gap-2">
						<EwButton :size="'sm'" type="secondary" label="Close" @click="handleClose(closeCallback)" />
					</div>
				</slot>
			</div>
		</template>
	</Sidebar>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { useEventBus } from '@vueuse/core'

import Sidebar from 'primevue/sidebar'
import { sidebarPanelProps, type SidebarPanelEmits } from './meta'

// Props dhe emits
const props = defineProps(sidebarPanelProps)
const emit = defineEmits<SidebarPanelEmits>()

// EventBus për rifreskim
const refreshListEvent = useEventBus<{ forceRefreshOnClose?: boolean }>('refresh-listview')
const shouldRefreshOnClose = computed(() => props.refreshOnClose === true)
const shouldRefreshPageOnClose = computed(() => props.refreshPageOnClose === true)

// Computed për panelin
const showPanel = computed({
	get: () => props.visible,
	set: (value) => emit('update:visible', value),
})

// Klasat e sidebarit sipas madhësisë
const sidebarClassList = computed(() => {
	const sidebarClassList = ['w-full']
	switch (props.size) {
		case 'sm':
			sidebarClassList.push('md:w-15rem')
			break
		case 'md':
			sidebarClassList.push('md:w-25rem')
			break
		case 'lg':
			sidebarClassList.push('md:w-45rem')
			break
		case 'xl':
			sidebarClassList.push('md:w-55rem')
			break
		case 'xxl':
			sidebarClassList.push('md:w-75rem')
			break
		case 'full':
			sidebarClassList.push('md:w-full')
			break
		case 'lngReviewEdit':
			sidebarClassList.push('md:w-full')
			break
		default:
			sidebarClassList.push(props.size)
			break
	}
	return sidebarClassList
})

// Header style
const headerClass = computed(() => {
	switch (props.headerStyle) {
		case 'brand':
		case 'dark':
		case 'author':
			return 'bg-dark text-white'
		default:
			return 'bg-dark text-white'
	}
})

// Mesazhet nga iframe për mbyllje
function handleMessage(event: MessageEvent) {
	// Filtro të gjithë mesazhet që nuk janë të tuat
	if (!event.data || typeof event.data !== 'object' || !('action' in event.data)) return

	console.log('📩 Mesazh nga iframe:', event.data)

	if (event.data.action === 'close-and-refresh') {
		console.log('✅ Po mbyllet sidebar + rifreskohet')
		showPanel.value = false
		refreshAfterClose(true)
	}
}

function refreshAfterClose(forceRefreshOnClose = false) {
	if (shouldRefreshPageOnClose.value) {
		window.location.reload()
		return
	}

	if (shouldRefreshOnClose.value) {
		refreshListEvent.emit(forceRefreshOnClose ? { forceRefreshOnClose: true } : undefined)
	}
}

// === NEW: handle manual close nga ikona "x"
function handleClose(closeCallback: () => void) {
  closeCallback()
  refreshAfterClose()
}


onMounted(() => {
	window.addEventListener('message', handleMessage)
})

onBeforeUnmount(() => {
	window.removeEventListener('message', handleMessage)
})
</script>
